import {useRef} from 'react'
import uniqid from 'uniqid'
import ReactionsModal from '../organism/ReactionsModal'
import ReactionItemTemplate from '../templates/ReactionItemTemplate'
import {useMedia} from '../../ui-kit/hooks/useMedia'
import {mediaFromM} from '../../ui-kit/helpers/media-queries'

const ReactionCounter = ({counter, reactions}) => {
  const modal = useRef()
  const fromM = useMedia(mediaFromM)

  const handleOpenModal = () => {
    modal.current.open()
  }

  return (
    <>
      <div className="reaction-counter" onClick={handleOpenModal}>
        <div className="reactions">
          {reactions.map(reaction => (
            <ReactionItemTemplate
              type={reaction}
              isProud={reaction === 'PROUD'}
              key={uniqid()}
              size="tiny"
              reaction={reaction}
            />
          ))}
        </div>
        <p className="counter">
          {counter} {fromM && <span className="counter-text">reacciones</span>}
        </p>
      </div>
      <ReactionsModal ref={modal} />
    </>
  )
}

export default ReactionCounter
